var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSantaBubbleText4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230 99",
    style: {
      enableBackground: "new 0 0 230 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:#FFFFFF;}\n\t\t.st1{font-family:'ArialMT';}\n\t\t.st2{font-size:13px;}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    className: "st0",
    d: "M218.8,0.05H11.2C5.02,0.05,0,5.05,0,11.22l0,0v66.44c0,6.17,5.02,11.16,11.2,11.16l0,0h2 l4.65,10.12l22.19-10.12H218.8c6.19,0,11.2-5,11.2-11.16V11.22C230,5.05,224.98,0.06,218.8,0.05"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.9629 33.6416)",
    style: {
      fontFamily: "Sans,Arial"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st1 st2",
    style: {
      fontFamily: "Sans,Arial"
    }
  }, "\n\t\t\tIf you would like to learn more\n\t\t"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15.6,
    className: "st1 st2",
    style: {
      fontFamily: "Sans,Arial"
    }
  }, "\n\t\t\tabout the Icelandic Christmas,\n\t\t"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 31.2,
    className: "st1 st2",
    style: {
      fontFamily: "Sans,Arial"
    }
  }, "\n\t\t\tclick here\n\t\t")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaBubbleText4);
export default __webpack_public_path__ + "static/media/santaBubbleText4.b14d24f106b01ae6f94c00ffd8f4a478.svg";
export { ForwardRef as ReactComponent };